import { shortenWalletAddress } from '../../utils/commonFunction';

export const normalizeWallet = (walletAddress) =>
    String(walletAddress || '')
        .trim()
        .toLowerCase();

export const formatDateTime = (value) => {
    if (!value) return 'Not set';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'Not set';
    return date.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};

/** Compact YYYY-MM-DD for table rows */
export const formatDateOnly = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

/** Readable due date for task cards, e.g. "Due May 13, 2026" */
export const formatDueDate = (value) => {
    if (!value) return 'No deadline set';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'No deadline set';
    const formatted = date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
    return `Due ${formatted}`;
};

/** Assignee line for task list rows: "Name (address)" when both exist. */
export const formatTaskAssignee = (task) => {
    const name = String(task?.employee?.name || '').trim();
    const wallet = task?.employee?.wallet;

    if (name && wallet) {
        return {
            primary: `${name} (${shortenWalletAddress(wallet)})`,
            secondary: null,
        };
    }
    if (name) {
        return { primary: name, secondary: null };
    }
    if (wallet) {
        return { primary: shortenWalletAddress(wallet), secondary: null };
    }
    return { primary: 'Unassigned', secondary: null };
};

/** Status pill — readable on light cards and dark cards. */
export const formatStatusTone = (status) => {
    const base =
        'inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide';
    if (status === 'approved' || status === 'released')
        return `${base} border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-500/25 dark:bg-emerald-950/70 dark:text-emerald-200`;
    if (status === 'disputed')
        return `${base} border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-500/28 dark:bg-amber-950/65 dark:text-amber-100`;
    if (status === 'refund_requested' || status === 'refunded')
        return `${base} border-orange-200 bg-orange-50 text-orange-900 dark:border-orange-500/25 dark:bg-orange-950/60 dark:text-orange-100`;
    if (status === 'submitted' || status === 'active')
        return `${base} border-teal-200 bg-teal-50 text-teal-900 dark:border-teal-500/25 dark:bg-teal-950/65 dark:text-teal-100`;
    if (status === 'rejected')
        return `${base} border-rose-200 bg-rose-50 text-rose-900 dark:border-rose-500/25 dark:bg-rose-950/60 dark:text-rose-100`;
    return `${base} border-zinc-300 bg-zinc-100 text-zinc-800 dark:border-slate-600/35 dark:bg-slate-900/90 dark:text-slate-200`;
};
